/* ============================================================
   AVANTI - mobile sticky buy bar
   Mirrors the real add-to-cart button rather than reimplementing
   it. IntersectionObserver rather than a scroll listener, so this
   costs nothing on the main thread while the visitor scrolls.
   ============================================================ */
(function () {
  'use strict';

  function init(bar) {
    var realBtn = document.querySelector('.product-form__submit');
    if (!realBtn) return;

    var stickyBtn = bar.querySelector('[data-sticky-add]');
    var priceEl = bar.querySelector('[data-sticky-price]');
    var qtyInput = bar.querySelector('[data-sticky-qty-input]');
    var qtyMinus = bar.querySelector('[data-sticky-qty-minus]');
    var qtyPlus = bar.querySelector('[data-sticky-qty-plus]');

    /* The real quantity field stays the source of truth: the bar writes to
       it and lets Dawn's own logic run, rather than keeping a second count
       that could drift out of step with the form being submitted. */
    function realQty() {
      return document.querySelector('.product-form__input .quantity__input, form[action*="/cart/add"] .quantity__input');
    }

    function pushQty(value) {
      var real = realQty();
      if (!real) return;
      real.value = value;
      real.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function pullQty() {
      var real = realQty();
      if (real && qtyInput && real.value) qtyInput.value = real.value;
    }

    function syncState() {
      var disabled = realBtn.hasAttribute('disabled');
      stickyBtn.disabled = disabled;
      var label = realBtn.querySelector('span');
      if (label && label.textContent.trim()) {
        stickyBtn.textContent = label.textContent.trim();
      }
      // price changes with the variant; mirror whatever the page shows
      var live = document.querySelector('.price__container .price-item--regular, .price-item--sale');
      if (live && priceEl) priceEl.textContent = live.textContent.trim();
      pullQty();
    }

    if (qtyMinus) qtyMinus.addEventListener('click', function () {
      var v = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
      qtyInput.value = v; pushQty(v);
    });
    if (qtyPlus) qtyPlus.addEventListener('click', function () {
      var v = (parseInt(qtyInput.value, 10) || 1) + 1;
      qtyInput.value = v; pushQty(v);
    });
    if (qtyInput) qtyInput.addEventListener('change', function () {
      var v = Math.max(1, parseInt(qtyInput.value, 10) || 1);
      qtyInput.value = v; pushQty(v);
    });

    stickyBtn.addEventListener('click', function () {
      if (qtyInput) pushQty(Math.max(1, parseInt(qtyInput.value, 10) || 1));
      realBtn.click();
    });

    // show the bar only while the real button is off screen
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          bar.hidden = entry.isIntersecting;
          if (!entry.isIntersecting) syncState();
        });
      }, { rootMargin: '0px 0px -40px 0px' });
      io.observe(realBtn);
    } else {
      bar.hidden = false;
      syncState();
    }

    // variant switches rewrite the form; keep label, price and state current
    if ('MutationObserver' in window) {
      new MutationObserver(syncState).observe(realBtn, {
        attributes: true,
        childList: true,
        subtree: true
      });
    }
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-avanti-sticky]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
